import { render } from "./OrdersDashboard.vue?vue&type=template&id=403d67f2&scoped=true"
import script from "./OrdersDashboard.vue?vue&type=script&lang=js"
export * from "./OrdersDashboard.vue?vue&type=script&lang=js"

import "./OrdersDashboard.vue?vue&type=style&index=0&id=403d67f2&scoped=true&lang=css"

import exportComponent from "C:\\Users\\PamelaOsunza\\OneDrive - dermapp.com\\Escritorio\\dermapp\\dermapp-pacientes-staging\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-403d67f2"]])

export default __exports__